export const SKOOLWEB_SOFTWARE_URL = 'https://skoolweb.f5universe.com/';
export const FUTURISTIC5_URL = 'https://www.futuristic5.com/';
export const CONTACT_PHONE = '+91 98605 44800';
export const CONTACT_PHONE_TEL = '+919860544800';
